import quickBIDesign from './_src/quickBIDesign.vue'
quickBIDesign.install = function(Vue) {
  Vue.component(quickBIDesign.name, quickBIDesign)
}

export default quickBIDesign